import React, { Component } from 'react'
import styled from 'styled-components'
import { FlexWrapper, XXLText, StyledLink, XLMMText, Arrow } from './'

const Anchor = styled.a`
  color: #078489;
  font-size: 16px;
  line-height: 1.56;
  display: inline-flex;
  align-items: center;
  & > div {
    width: 8px;
    height: 8px;
    border-left: 1.5px solid #078489;
    border-bottom: 1.5px solid #078489;
    transform: rotate(225deg);
  }
`
const LinkModified = styled(StyledLink)`
  display: inline-flex;
  & > div {
    width: 8px;
    height: 8px;
    border-left: 1.5px solid #078489;
    border-bottom: 1.5px solid #078489;
    transform: rotate(225deg);
  }
  align-items: center;
`
class TopSection extends Component {
  static defaultProps = {
    viewAllText: 'View all'
  }
  state = {}
  render() {
    const { title, to, subTitle, redirect, viewAllText, padding, noSubtitle, margin } = this.props
    return (
      <FlexWrapper
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        viewPadding={padding ? padding : '30px 16px 0px'}
        viewMargin={margin}
        position="relative">
        {subTitle ? (
          <FlexWrapper>
            <XXLText color="#124b5f" font="Chivo">
              {title}
            </XXLText>
            <FlexWrapper direction="row" justifyContent="space-between" alignItems="center">
              <XLMMText fontStyle="italic" color="#078489">
                {subTitle}
              </XLMMText>
              {to && (
                <LinkModified to={to}>
                  {viewAllText} <Arrow margin="0 0 2px 0" />
                </LinkModified>
              )}
              {redirect && (
                <Anchor href={redirect} target="_blank" rel="noopener noreferrer">
                  {viewAllText} <Arrow margin="0 0 2px 0" />
                </Anchor>
              )}
            </FlexWrapper>
          </FlexWrapper>
        ) : noSubtitle ? (
          <React.Fragment>
            <XXLText color="#124b5f" font="Chivo" textAlign="left" smallMobile>
              {title}
            </XXLText>
            {to && (
              <LinkModified to={to}>
                {viewAllText} <Arrow margin="0 0 2px 0" />
              </LinkModified>
            )}
          </React.Fragment>
        ) : (
          <XXLText color="#124b5f" font="Chivo">
            {title}
          </XXLText>
        )}
      </FlexWrapper>
    )
  }
}

export default TopSection



// WEBPACK FOOTER //
// ./src/components/TopSection.js